import { Flex, Text } from "@chakra-ui/react";
import { NumberField } from "../../../components/NumberField";
import * as React from "react";
import { useTranslation } from "react-i18next";

function ScopeTotalsAndApportioned({ data, scopeIndex, organizationName }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierDashboard.charts"
  });

  const getApportionedValue = (totalValue, apportionedValue) => {
    return totalValue && typeof totalValue !== "undefined" ? (
      <Text fontSize="md" fontWeight="600">
        ({organizationName} {t("associatedEmissions")}: <b>{apportionedValue?.toLocaleString("en-GB", { maximumFractionDigits: 4 }) ?? "n/a"}</b>)
      </Text>
    ) : "";
  };

  return (
    <Flex alignItems="center" gap={2}>
      <Text fontSize="lg">
        {t("scope")} {scopeIndex}{scopeIndex === 3 ? "*" : ""}:
      </Text>
      <NumberField fontSize="2xl" fontWeight="bold" value={data[`scope${scopeIndex}TotalCo2Emissions`]} />
      {getApportionedValue(data[`scope${scopeIndex}TotalCo2Emissions`], data[`scope${scopeIndex}ApportionedCo2Emissions`])}
    </Flex>
  );
}

export default ScopeTotalsAndApportioned;